export const parseChip = (c) => {
  if (c.duplicate_status === "pending") return "Needs review";
  if (c.parse_status === "needs_attention" && c.parse_error?.startsWith("No resume")) return "No resume";
  return { queued: "Queued", processing: "Processing", ready: "Ready", needs_attention: "Failed" }[c.parse_status];
};

export const SOURCE_LABELS = { upload: "Job resume upload", careers: "Careers page", seed: "Demo seed", manual: "Manual", manual_upload: "Manual upload", bulk_import: "Bulk import" };

export const STAGE_LABELS = { onboard: "Onboard", screen_shortlist: "Screen and shortlist", assess: "Assess", interview: "Interview", offer: "Offer" };

export const LOW_CONF_LABELS = {
  contact: "Contact details", summary: "Summary", skills: "Skills", experience: "Experience",
  education: "Education", certifications: "Certifications",
};

export const monthLabel = (ym) => {
  if (!ym) return "";
  const [y, m] = ym.split("-");
  return new Date(Number(y), Number(m) - 1, 1).toLocaleDateString("en-GB", { month: "short", year: "numeric" });
};
